// import components
import Grid, { GridProps } from '@mui/material/Grid';

export const StyledRealizationGrid = (props: GridProps) => (
  <Grid
    size={{ compact: 12, medium: 4 }}
    sx={{ marginBottom: (theme) => theme.spacing(2) }}
    {...props}
  />
);
